import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { FileDown, Shield, Droplets, HardHat } from "lucide-react";
import previewNachbehandlung from "@/assets/preview-nachbehandlung.jpg";
import previewWasserzugabe from "@/assets/preview-wasserzugabe.jpg";
import previewSicherheit from "@/assets/preview-sicherheit.jpg";

const infos = [
  {
    icon: HardHat,
    title: "Nachbehandlung von Beton",
    description: "Erfahren Sie, wie Sie Ihren Beton richtig nachbehandeln, damit er seine volle Festigkeit erreicht. Schutz vor Austrocknung und Frost ist entscheidend.",
    downloadLabel: "PDF herunterladen",
    href: "/downloads/beton2go_nachbehandlung.pdf",
    preview: previewNachbehandlung,
  },
  {
    icon: Droplets,
    title: "Wasserzugabe",
    description: "Warum die richtige Wassermenge entscheidend ist und wann auf keinen Fall Wasser nachgegeben werden darf. Wichtige Hinweise für die Verarbeitung.",
    downloadLabel: "PDF herunterladen",
    href: "/downloads/beton2go_wasserzugabe.pdf",
    preview: previewWasserzugabe,
  },
  {
    icon: Shield,
    title: "Sicherheitsdatenblatt",
    description: "Alle wichtigen Sicherheitsinformationen für den Umgang mit Frischbeton. Schutzausrüstung, Erste Hilfe und Entsorgungshinweise.",
    downloadLabel: "PDF herunterladen",
    href: "/downloads/beton2go_sicherheitsdatenblatt.pdf",
    preview: previewSicherheit,
  },
];

const Betoninfos = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-32 pb-16">
          <div className="container mx-auto px-4 text-center">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}>
              <h1 className="font-display text-5xl md:text-6xl font-bold mb-4">
                Beton<span className="text-primary">infos</span>
              </h1>
              <p className="text-muted-foreground max-w-xl mx-auto">
                Wichtige Dokumente rund um Verarbeitung und Sicherheit.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Downloads with Preview Images */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="font-display text-3xl md:text-4xl font-bold mb-12 text-center">
              Downloads & <span className="text-primary">Dokumente</span>
            </h2>
            <div className="flex flex-col gap-10 max-w-5xl mx-auto">
              {infos.map((info, i) => (
                <motion.div
                  key={info.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.15 }}
                  className="bg-card border border-border overflow-hidden group hover:border-primary/40 transition-colors"
                >
                  <div className="grid md:grid-cols-[1fr_250px] gap-0">
                    {/* Info */}
                    <div className="p-8 flex flex-col justify-center">
                      <div className="w-14 h-14 bg-primary/10 flex items-center justify-center mb-6">
                        <info.icon className="h-7 w-7 text-primary" />
                      </div>
                      <h3 className="font-display text-xl font-bold mb-3">{info.title}</h3>
                      <p className="text-muted-foreground text-sm leading-relaxed mb-6">{info.description}</p>
                      <a
                        href={info.href}
                        download
                        className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 font-display text-sm tracking-wider hover:bg-primary/80 transition-colors w-fit"
                      >
                        <FileDown className="h-4 w-4" />
                        {info.downloadLabel}
                      </a>
                    </div>
                    {/* Preview Image */}
                    <div className="border-t md:border-t-0 md:border-l border-border bg-muted/30 p-4 flex items-center justify-center">
                      <img
                        src={info.preview}
                        alt={`Vorschau: ${info.title}`}
                        className="w-full h-auto max-h-[350px] object-contain shadow-lg border border-border"
                      />
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Betoninfos;
